import { useEffect } from 'react'
import { MaybeErrorData } from '../components'
import { useErrorHandling } from '../contexts'

export const useErrorTrigger = (errorData: MaybeErrorData) => {
  const { setErrorData } = useErrorHandling()

  useEffect(() => {
    if (errorData) {
      setErrorData(errorData)
    }
  }, [errorData, setErrorData])
}
